import React from 'react'
import PropTypes from 'prop-types'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import DeviceWarningUi from './ui/DeviceWarningUi'

type DeviceWarningProps = {
  deviceWarning: 'desktop_only' | 'mobile_only'
}

function DeviceWarning({ deviceWarning }: DeviceWarningProps) {
  const { t } = useTypedTranslation()

  return (
    <DeviceWarningUi>{t(`entity.warning.${deviceWarning}`)}</DeviceWarningUi>
  )
}

DeviceWarning.propTypes = {
  deviceWarning: PropTypes.string.isRequired,
}

export default DeviceWarning
